import { useState } from 'react';
import { useClient } from '../client';
import type { ModerationReport } from '../api';
import { FanNav } from '../ui/Nav';

export function Moderation() {
  const client = useClient();
  const [token, setToken] = useState('');
  const [reports, setReports] = useState<ModerationReport[]>();
  const [error, setError] = useState<string>();
  const [confirm, setConfirm] = useState<string>();
  const [busy, setBusy] = useState(false);
  const load = async () => {
    setBusy(true); setError(undefined);
    try { setReports(await client.moderationReports(token)); } catch { setError('Couldn’t load reports. Check your moderator key and connection.'); }
    finally { setBusy(false); }
  };
  return <main className="library"><FanNav /><header className="library__intro"><p className="eyebrow">BETA OPERATIONS</p><h1>Review reports.</h1><p>Watch reported takes and remove content that violates the community rules.</p></header>
    <form className="moderator-access" onSubmit={(e) => { e.preventDefault(); void load(); }}><label>Moderator key<input type="password" autoComplete="off" value={token} onChange={(e) => setToken(e.target.value)} /></label><button className="btn btn--primary" disabled={busy}>{busy ? 'Loading…' : 'Load reports'}</button></form>
    {error && <p role="alert">{error}</p>}{reports?.length === 0 && <p>No reports yet.</p>}
    <div className="take-grid">{reports?.map((r) => <article className="saved-take" key={r.reportId}><div className="saved-take__body"><span className="eyebrow">{r.reason} · {new Date(r.at).toLocaleString()}</span>
      {r.take ? <><h2>{r.take.displayName}</h2><video controls preload="metadata" playsInline src={client.takeUrl(r.take)} style={{ width: '100%' }} />
        <button className="btn btn--ghost" disabled={busy} onClick={async () => {
          if (confirm !== r.takeId) return setConfirm(r.takeId);
          setBusy(true);
          try { await client.moderateTake(r.take!, token); await load(); } catch { setError('Couldn’t remove the recording.'); }
          finally { setBusy(false); setConfirm(undefined); }
        }}>{confirm === r.takeId ? 'Confirm permanent removal' : 'Remove recording'}</button></> : <p>Recording removed.</p>}
    </div></article>)}</div>
  </main>;
}
